import React from "react";
import { Navigate } from "react-router-dom";
import { useRBA } from "./useRBA";
import { LoadingScreen } from "../components/LoadingScreen/LoadingScreen";
import { NoAccessScreen } from "../components/no-access/NoAccess";
import type { UserRoles } from "../Constant";
import type { PolicyPath } from "../Types";

interface ProtectedRouteProps {
  children: React.ReactNode;
  feature?: string;
  requiredRoles?: UserRoles[];
  policy?: PolicyPath;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  feature,
  requiredRoles,
  policy,
}) => {
  const {
    isReady,
    isLoading,
    isAuthenticated,
    isAllowed,
    hasAnyRole,
    isFeatureEnabled,
  } = useRBA();

  if (isLoading) {
    return <LoadingScreen messageQueue="Verifying session..." />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (feature && !isFeatureEnabled(feature)) {
    return <NoAccessScreen />;
  }

  if (requiredRoles && !hasAnyRole(requiredRoles)) {
    return <NoAccessScreen />;
  }

  if (policy && !isAllowed(policy)) {
    return <NoAccessScreen />;
  }

  if (!isReady) {
    return <LoadingScreen messageQueue="Loading access profile..." />;
  }

  return <>{children}</>;
};
